<div class="edesk-selector-overlay">
  <div class="edesk-selector-dialog" role="dialog" aria-modal="true" aria-labelledby="edesk-selector-title">
    <div class="edesk-selector-header">
      <h2 class="govuk-heading-m" id="edesk-selector-title">Vyberte eDesk</h2>
      <button
        *ngIf="edeskStateService.selectedEdeskUri()"
        class="edesk-selector-close"
        type="button"
        aria-label="Zavrieť"
        (click)="cancel()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <p class="govuk-body">Váš účet má prístup k viacerým eDesk schránkam. Vyberte schránku, ktorú chcete použiť.</p>

    <ul class="govuk-list edesk-selector-list">
      <li *ngFor="let delegation of delegations">
        <button
          class="govuk-button govuk-button--secondary edesk-selector-btn"
          [class.edesk-selector-btn--active]="edeskStateService.selectedEdeskUri() === delegation.edesk?.uri"
          type="button"
          (click)="selectEdesk(delegation.edesk?.uri ?? '')">
          <span class="edesk-selector-uri">{{ delegation.edesk?.label ?? shortUri(delegation.edesk?.uri) }}</span>
        </button>
      </li>
    </ul>
  </div>
</div>
